import { buildAxiosInstance } from '../../../utils/apiUtils'
import { globalMerchantsProxy } from '../../../proxies/globalMerchantsProxy'
import { type GlobalMerchantType } from '../../../types/GlobalMerchantType'
import { type GlobalUserType } from '../../../types/GlobalUserType'

interface ResponseData {
  merchants: GlobalMerchantType[]
}

interface Response {
  data: ResponseData | null
  error: string | null
}

export const executeRetrieveMerchants = async (user: GlobalUserType): Promise<GlobalMerchantType | undefined> => {
  try {
    const userMid = user.merchant?.ppMerchantId
    globalMerchantsProxy.apiCall.loading = true
    globalMerchantsProxy.apiCall.error = null
    const axiosInstance = buildAxiosInstance()
    const response = await axiosInstance.post<Response>('/api/merchants/search')

    const merchants = response.data?.data?.merchants
    if (merchants) {
      globalMerchantsProxy.merchants = merchants
      if (merchants.length > 0) {
        const matchingMerchant = merchants.find(m => { return m.ppMerchantId === userMid })
        if (!matchingMerchant) {
          globalMerchantsProxy.apiCall.error = 'Unable to find merchant'
        } else {
          globalMerchantsProxy.selectedMerchant = matchingMerchant
          return matchingMerchant
        }
      }
    }
  } catch (e) {
    if (e instanceof Error) {
      globalMerchantsProxy.apiCall.error = e.message
    }
  } finally {
    globalMerchantsProxy.apiCall.loading = false
  }
}
